import videojs, { VideoJsPlayer } from 'video.js';
import { log } from '../../services/logs';

const { pixelsjs } = window;
const Plugin: typeof videojs.Plugin = pixelsjs.getPlugin('plugin')

class PreferCloseCaption extends Plugin {
  constructor(player) {
    super(player);
  }

  disableCC() {
    const player = this.player as VideoJsPlayer;
    let hasBeenRunProgrammatically = false;

    const closeCaptionListener = (e: Event) => {
      if (hasBeenRunProgrammatically) {
        player.off(e.type, closeCaptionListener);
        return;
      }

      const tracks = player.textTracks();
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];

        if (!['captions', 'subtitles'].includes(track.kind)) {
          continue;
        }

        log('pixels track.mode', track.mode);
        if (track.mode === 'showing') {
          track.mode = 'disabled';
          log('pixels track.mode disabled', track.mode);
          hasBeenRunProgrammatically = true;
        }
      }
    };
     [
      'timeupdate'
    ].forEach((type) => player.on(type, closeCaptionListener));
  }

  setCC(lang: string, options: Record<string, any>) {
    const player = this.player as VideoJsPlayer;

    const opts = {
      fontPercent: 2,
      ...options
    };

    let hasBeenRunProgrammatically = false;
    const closeCaptionListener = (e: Event) => {
      if (hasBeenRunProgrammatically) {
        player.off(e.type, closeCaptionListener);
        return;
      }

      const tracks = player.textTracks();
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];

        if (!['captions', 'subtitles'].includes(track.kind)) {
          continue;
        }

        if (track.language === lang) {
          track.mode = 'showing';
          hasBeenRunProgrammatically = true;
          const settings = player.textTrackSettings;
          settings.setValues(opts);
          settings.updateDisplay();
        } else {
          track.mode = 'disabled';
        }
      }
    };

    [
      'timeupdate'
    ].forEach((type) => player.on(type, closeCaptionListener));

  }
}

pixelsjs.registerPlugin('preferCloseCaption', PreferCloseCaption);
